/* ══════════════════════════════════════════════════════════════════
   47X · V6.2.1 · MOTOR DE POPUPS ORIENTADO A REVENUE (pgx47)

   QUÉ HACE Y QUÉ NO. Decide cuándo mostrar, cambia estado y mide.
   NO mueve nodos, no reparenta, no toca scrollRestoration, no llama a
   scrollTo y no modifica body ni html de forma que desplace el
   documento. El contenedor ya viene de Liquid en su sitio: aquí solo
   se le pone o quita una clase.

   PRIORIDAD  P3 cierre > P1 captación > P2 consideración.
   Con carrito manda P3; sin carrito y visitante nuevo, P1; si P1 no
   aplica y sigue navegando sin carrito, P2.
   TOPE 2 popups grandes por sesión · ENFRIADO 3-5 min, contado desde
   que se CIERRA el anterior, así nunca sale uno pegado a otro.

   HOLDOUT. Un 10-15% de las sesiones elegibles no ve ningún popup y
   queda marcado como control. Sin grupo de control no hay forma de
   saber si el popup vende o solo estorba.

   Sin librerías · sin polling · sin timers duplicados. El reloj se
   pausa con la pestaña y se reanuda al volver.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.Pgx47) return;

  var cfg = { max: 3, enfriado: 60, holdout: 12 };   /* uno de cada · 60 s entre ellos */
  var regs = [], abierto = null, arrancado = false;

  /* ══ MODO QA ══════════════════════════════════════════════════
     Solo vive fuera del tema publicado. `Shopify.theme.role` dice
     'main' en el LIVE: ahí esto no se enciende ni por error, y el
     coste para un cliente real es una comparación de cadenas.

     El registro de por qué NO salió se enciende en cualquier tema no
     publicado. No hay interfaz de pruebas: ni paneles, ni botones, ni
     enlaces especiales. Solo consola, y solo fuera del publicado. */
  /* Fuera del tema publicado se deja registro en consola: es lo único que
     queda del modo de pruebas. Sin paneles, sin botones, sin enlaces
     especiales. Para un cliente esto cuesta una comparación de cadenas. */
  var QA = (function () {
    var rol = '';
    try { rol = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || ''; } catch (e) {}
    var editor = false;
    try { editor = !!(window.Shopify && window.Shopify.designMode); } catch (e) {}
    var fuera = editor || (rol !== '' && rol !== 'main');
    return { staging: fuera, log: fuera, activo: false, popup: '', contexto: '' };
  })();

  function log(txt) { if (QA.log) { try { console.log('[47x popups] ' + txt); } catch (e) {} } }

  /* ══ ESCALA DE PRUEBA ═════════════════════════════════════════
     En producción las exclusiones son largas a propósito: 75 días sin
     volver a pedir el correo, 3 minutos entre intervenciones. Pero eso
     vuelve el staging imposible de revisar: basta una prueba para que
     el propio sistema te excluya y parezca que está roto.

     Fuera del tema publicado, las MISMAS reglas corren con relojes
     cortos. La lógica no cambia —sigue excluyendo, sigue enfriando—,
     solo se mide en minutos en vez de días. El holdout se apaga: en
     una revisión no tiene sentido caer en el grupo de control.
     Nada de esto existe en el tema publicado.                       */
  var PRUEBA = QA.staging;
  function dias(reales) { return PRUEBA ? (2 / 1440) : reales; }   /* 2 minutos */


  /* En QA no se escribe NADA persistente: la sesión del QA no puede
     ensuciar las reglas reales ni las métricas. */
  function marca(fn) { if (QA.activo) return; fn(); }

  function ss(k, v) { try { return v === undefined ? sessionStorage.getItem(k) : (sessionStorage.setItem(k, v), v); } catch (e) { return null; } }
  function ls(k, v) { try { return v === undefined ? localStorage.getItem(k) : (localStorage.setItem(k, v), v); } catch (e) { return null; } }
  var ahora = function () { return Date.now(); };

  /* ── contexto de la sesión · se lee una vez ── */
  var ctx = {
    carrito: 0, valor: 0, cliente: false,
    pagina: location.pathname,
    fuente: (function () {
      try {
        var q = new URLSearchParams(location.search);
        return q.get('utm_source') || q.get('utm_medium') ||
               (/facebook|instagram|fbclid/i.test(location.search + document.referrer) ? 'meta' : '') ||
               (document.referrer ? 'referral' : 'directo');
      } catch (e) { return ''; }
    })()
  };
  ctx.pago = /meta|facebook|instagram|paid|cpc/i.test(ctx.fuente);

  function pub(nombre, extra) {
    var d = { popup_id: (extra && extra.popup_id) || '', variant: (extra && extra.variant) || 'a',
              page: ctx.pagina, cart_value: ctx.valor, source: ctx.fuente };
    for (var k in (extra || {})) d[k] = extra[k];
    if (QA.activo) {                       /* en prueba forzada no se contamina nada */
      d.debug = true;
      log('EVENTO (no enviado) ' + nombre + ' ' + JSON.stringify(d));
      return;
    }
    try { if (window.Ev47 && window.Ev47.pub) window.Ev47.pub(nombre, d); } catch (e) {}
  }

  /* ── holdout · estable durante toda la sesión ── */
  function esControl() {
    if (QA.activo) return false;           /* la prueba forzada nunca cae en el control */
    var v = ss('pgx47:grupo');
    if (!v) {
      /* sin Math.random no hay reparto; se usa solo aquí y una vez */
      v = (Math.random() * 100 < cfg.holdout) ? 'control' : 'popup';
      ss('pgx47:grupo', v);
      if (v === 'control') pub('popup_holdout', { grupo: 'control' });
    }
    return v === 'control';
  }

  function zonaProhibida() {
    return /\/(checkouts?|account|orders|challenge|tools)(\/|$)/.test(location.pathname);
  }

  /* ══ ESTADO DEL EMBUDO ══════════════════════════════════════
     Nunca se muestra una etapa anterior a la que el cliente ya pasó.
       checkout_iniciado → nada
       carrito_con_productos → solo P3
       intencion → P2
       visitante_nuevo → P1                                        */
  function checkoutIniciado() {
    if (/\/checkouts?(\/|$)/.test(location.pathname)) { ss('pgx47:checkout', '1'); return true; }
    return ss('pgx47:checkout') === '1';
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="/checkout"],[name="checkout"],[data-checkout]');
    if (a) ss('pgx47:checkout', '1');
  }, true);

  function estado() {
    if (checkoutIniciado()) return 'checkout_iniciado';
    if (ctx.carrito > 0) return 'carrito_con_productos';
    return 'visitante_sin_carrito';
  }

  function cuenta() { return parseInt(ss('pgx47:sesion') || '0', 10) || 0; }
  function ultimo() { return parseInt(ss('pgx47:ultimo') || '0', 10) || 0; }

  /* Devuelve '' si se puede, o el nombre de la regla que lo impide. */
  function bloqueo() {
    if (abierto) return 'another_popup_open';
    if (zonaProhibida()) return 'forbidden_zone';
    /* En el editor de temas no salen solos: taparían lo que se edita. */
    if (document.querySelector('[data-pgx47-editor]') && !QA.activo) return 'theme_editor';
    if (QA.activo) return '';              /* forzado: el resto de reglas se ignora */
    if (checkoutIniciado()) return 'checkout_started';   /* ya avanzó: no se le estorba */
    if (cuenta() >= cfg.max) return 'max_per_session';
    var falta = Math.ceil((cfg.enfriado * 1000 - (ahora() - ultimo())) / 1000);
    if (falta > 0) return 'cooldown_active (' + falta + 's restantes)';
    if (window.__pop47lock) return 'other_modal_open';
    if (esControl()) return 'holdout';
    return '';
  }
  function puedeAbrir() { return bloqueo() === ''; }

  /* ── reloj que se pausa con la pestaña ── */
  function Reloj(ms, alSonar) {
    var resto = ms, t = null, desde = 0, muerto = false;
    this.arranca = function () {
      if (muerto || t || document.hidden) return;
      desde = ahora();
      t = setTimeout(function () { t = null; if (!muerto) alSonar(); }, resto);
    };
    this.pausa = function () {
      if (!t) return;
      clearTimeout(t); t = null;
      resto = Math.max(0, resto - (ahora() - desde));
    };
    this.mata = function () { muerto = true; this.pausa(); };
  }

  var pintado = false;
  function diagrama() {
    if (!QA.log || pintado) return;
    pintado = true;
    var ruta = ['', '', ''];
    var e = estado();
    log('┌─ ESTADO DEL USUARIO ─────────────────────────');
    log('│  embudo        : ' + e);
    log('│  carrito       : ' + ctx.carrito + ' art. · $' + ctx.valor);
    log('│  grupo         : ' + (ss('pgx47:grupo') || '(sin asignar)'));
    log('│  intervenciones: ' + cuenta() + '/' + cfg.max + ' en esta sesión');
    var falta = Math.ceil((cfg.enfriado * 1000 - (ahora() - ultimo())) / 1000);
    log('│  enfriado      : ' + (falta > 0 ? falta + 's restantes' : 'libre'));
    log('│  elegible según el embudo: ' +
        (e === 'checkout_iniciado' ? 'ninguno' :
         e === 'carrito_con_productos' ? 'P3 (aún no construido)' : 'P1 → luego P2'));
    log('└──────────────────────────────────────────────');
  }

  /* COLA DE ESPERA DEL ENFRIADO.
     No es un parche: es cómo debe comportarse el enfriado. Si un popup
     cumple sus condiciones mientras corre el enfriado del anterior, lo
     correcto es que espere su turno, no que pierda la oportunidad.

     Medido al quitarlo: P1 y P3 seguían saliendo bien, pero P2 dejaba de
     aparecer por completo — su disparo (55 % o 45 s) cae dentro de los
     60 s de enfriado de P1 y sin esto nadie lo vuelve a intentar.

     Un solo setTimeout, programado justo para cuando expira el enfriado.
     No se encadena: si vuelve a estar bloqueado, no reprograma. */
  var enCola = null;
  function esperaTurno(razon) {
    if (enCola) return;
    var m = /cooldown_active \((\d+)s/.exec(razon);
    if (!m) return;                          /* solo el enfriado hace cola */
    var ms = (parseInt(m[1], 10) + 2) * 1000;
    if (ms > 300000) return;
    log('  ↻ en cola · su turno en ' + Math.round(ms / 1000) + 's');
    enCola = setTimeout(function () {
      enCola = null;
      /* Con la pestaña al fondo no se abre nada: aparecería a escondidas y
         la persona se la encontraría ya abierta, con un contexto calculado
         sobre una pantalla que no estaba mirando. Se espera a que vuelva y
         ahí se revalida todo desde cero. */
      if (document.hidden) {
        log('  ↻ turno en pausa · pestaña al fondo');
        document.addEventListener('visibilitychange', function alVolver() {
          if (document.hidden) return;
          document.removeEventListener('visibilitychange', alVolver);
          log('  ↻ vuelve la pestaña · revalidando');
          intenta('turno-tras-volver');
        });
        return;
      }
      intenta('turno');
    }, ms);
  }
  /* Si algo abre un popup mientras hay cola, la cola se descarta: cuando ese
     popup se cierre, su propio enfriado volverá a encolar lo que toque. */
  function cancelaCola() { if (enCola) { clearTimeout(enCola); enCola = null; } }

  function intenta(motivo) {
    diagrama();
    var glob = bloqueo();
    if (glob) {
      log('BLOCKED (todos): ' + glob);
      esperaTurno(glob);
      /* Aunque una regla global lo frene, se dice también qué habría dicho
         cada popup por su cuenta. Si no, un holdout tapa el motivo real y
         uno se queda sin saber si además había otra cosa mal. */
      if (QA.log) {
        for (var g = 0; g < regs.length; g++) {
          var suyo = '';
          try { suyo = regs[g].puede(ctx, motivo); } catch (e) { suyo = 'error'; }
          try { window.Pgx47['__r' + regs[g].id.slice(1)] = suyo || ('solo lo frena: ' + glob); } catch (e) {}
          log('  └ ' + regs[g].id.toUpperCase() + (suyo ? ': ' + suyo : ': elegible, solo lo frena lo de arriba'));
        }
      }
      return;
    }
    regs.sort(function (a, b) { return a.prioridad - b.prioridad; });
    for (var i = 0; i < regs.length; i++) {
      var r = regs[i];
      if (QA.activo && QA.popup && r.id !== QA.popup) continue;   /* solo el pedido */
      if (r.gastado) { log(r.id.toUpperCase() + ' BLOCKED: already_shown_this_page'); continue; }
      var res = '';
      try { res = r.puede(ctx, motivo); } catch (e) { res = 'error'; }
      try { window.Pgx47['__r' + r.id.slice(1)] = (res === true || res === '') ? 'nada' : res; } catch (e) {}
      if (res === true || res === '') { abre(r, motivo); return; }
      log(r.id.toUpperCase() + ' BLOCKED: ' + res);
    }
  }

  function abre(r, motivo) {
    /* En el editor de tema la sección SÍ se renderiza (es la única forma de
       que sus ajustes aparezcan en la barra lateral), pero los popups no
       deben saltar encima de quien está editando. */
    try { if (window.Shopify && window.Shopify.designMode) return false; } catch (e) {}
    if (!puedeAbrir()) return;
    var n = r.nodo;
    if (!n) return;
    cancelaCola();
    abierto = r; r.gastado = true;
    window.__pop47lock = 1;
    marca(function () {
      /* Se mantiene esta marca: otros módulos del tema la leen para no
         encimarse. No cuesta nada y evita sorpresas si alguno revive. */
      ss('pop47_shown_session', '1');
      ss('pgx47:sesion', String(cuenta() + 1));
      ss('pgx47:ultimo', String(ahora()));
    });
    log(r.id.toUpperCase() + ' SHOWN' + (QA.activo ? ' (forzado por QA)' : '') + ' · motivo=' + motivo);

    if (r.antesDeAbrir) { try { r.antesDeAbrir(); } catch (e) {} }
    /* Con una hoja abierta (P2/P3) los botones flotantes de la esquina se
       apartan: si no, Taco y WhatsApp quedan justo sobre el CTA. No se
       desmontan, solo se retiran con opacity y transform. */
    if (r.id === 'p2' || r.id === 'p3') document.documentElement.classList.add('pgx47-hoja-abierta');
    n.classList.add('is-montado');
    /* dos fotogramas: el primero pinta a opacidad 0, el segundo anima */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { n.classList.add('is-abierto'); });
    });
    document.addEventListener('keydown', esc);
    try { if (r.alAbrir) r.alAbrir(motivo); } catch (e) {}
  }

  function esc(e) { if (e.key === 'Escape') cierra('escape'); }

  function cierra(como) {
    if (!abierto) return;
    var r = abierto; abierto = null;
    document.removeEventListener('keydown', esc);
    var n = r.nodo;
    if (n) {
      n.classList.remove('is-abierto');
      setTimeout(function () { n.classList.remove('is-montado'); }, 260);
    }
    document.documentElement.classList.remove('pgx47-hoja-abierta');
    window.__pop47lock = 0;
    /* pop47Release era del guard legacy, ya retirado. Se sigue llamando SOLO
       si existe, por si otro módulo del tema lo define; el motor no lo
       necesita para nada. */
    try { if (window.pop47Release) window.pop47Release(); } catch (e) {}
    marca(function () { ss('pgx47:ultimo', String(ahora())); });  /* el enfriado cuenta desde el cierre */
    try { if (r.alCerrar) r.alCerrar(como); } catch (e) {}
  }

  function conecta() {
    if (arrancado) return;
    arrancado = true;
    document.addEventListener('visibilitychange', function () {
      for (var i = 0; i < regs.length; i++) {
        var r = regs[i]; if (!r.reloj) continue;
        if (document.hidden) r.reloj.pausa(); else r.reloj.arranca();
      }
    });
    /* bfcache: al volver con back este script no se re-ejecuta. El
       listener ya vive en memoria, así que no se duplica nada. */
    window.addEventListener('pageshow', function (e) {
      if (!e || !e.persisted) return;
      window.__pop47lock = abierto ? 1 : 0;
      intenta('bfcache');
    });
  }

  /* ── HUECO INFERIOR ──────────────────────────────────────────
     Cuánto hay que dejar libre abajo para no montarse sobre la barra de
     envío, el sticky de compra o los botones flotantes.

     Se mide por EXISTENCIA, no por visibilidad. Medido: la barra de envío
     se esconde arriba del todo y reaparece al bajar, así que medir solo lo
     visible hacía que la hoja saltara 81 px entre una posición y otra.
     Midiendo el elemento aunque esté fuera de pantalla, el valor es
     constante y la hoja no se mueve nunca.

     El resultado se escribe una sola vez en <html>, y de ahí lo toman P2 y
     P3 por CSS. No se recalcula en cada scroll: no hace falta. */
  function midaHueco() {
    var alto = 0;
    try {
      var todos = document.querySelectorAll('body *');
      for (var i = 0; i < todos.length; i++) {
        var el = todos[i];
        if (el.closest && el.closest('.pgx47')) continue;
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none') continue;
        var h = el.offsetHeight || 0;
        if (!h) continue;
        /* Una barra inferior es una tira, no una capa. Sin este tope se
           colaba un overlay a pantalla completa (hdr47-overlay) y la hoja
           acababa fuera de la pantalla, 187 px por encima del borde. */
        if (h > window.innerHeight * 0.22) continue;
        var w = el.offsetWidth || 0;
        if (w < window.innerWidth * 0.6) continue;          /* solo barras anchas */
        /* anclada abajo: su borde inferior cae cerca del fondo del viewport,
           o su CSS la fija con bottom:0 */
        var abajo = (cs.bottom === '0px' || cs.bottom === '0') ||
                    (el.getBoundingClientRect().bottom > window.innerHeight - 8);
        if (!abajo) continue;
        if (h > alto) alto = h;
      }
    } catch (e) {}
    try { document.documentElement.style.setProperty('--pgx47-safe', Math.round(alto) + 'px'); } catch (e) {}
    return alto;
  }
  midaHueco();
  window.addEventListener('resize', function () {
    clearTimeout(window.__pgx47rz);
    window.__pgx47rz = setTimeout(midaHueco, 200);
  }, { passive: true });
  window.addEventListener('load', function () { setTimeout(midaHueco, 1200); }, { once: true });

  /* ── AVISO DE CARRITO ────────────────────────────────────────
     No se confía en los nombres de eventos del tema. Medido: unos se
     disparan en `window` y otros en `document`, y el de agregar es
     `cart47:added`, que no coincidía con lo que se escuchaba — por eso
     P3 no se armaba nunca al agregar desde el botón real.

     Ahora se escuchan los tres nombres en los DOS destinos, y además se
     envuelve fetch: cualquier petición a /cart/add, /cart/change o
     /cart/update avisa, venga del tema o de una app. Sin polling. */
  var oyentes = [];
  function alCambiarCarrito(fn) { oyentes.push(fn); }
  function avisaCarrito(origen) {
    leeCarrito(function () {
      log('CARRITO cambió (' + origen + ') · ' + ctx.carrito + ' art. · $' + ctx.valor);
      for (var i = 0; i < oyentes.length; i++) { try { oyentes[i](origen); } catch (e) {} }
    });
  }
  ['cart47:refresh', 'cart47:open', 'cart47:close', 'cart47:added', 'cart:refresh'].forEach(function (ev) {
    window.addEventListener(ev, function () { avisaCarrito(ev); });
    document.addEventListener(ev, function () { avisaCarrito(ev); });
  });
  (function () {
    if (!window.fetch || window.__pgx47fetch) return;
    window.__pgx47fetch = 1;
    var orig = window.fetch;
    window.fetch = function (u) {
      var url = '';
      try { url = typeof u === 'string' ? u : (u && u.url) || ''; } catch (e) {}
      var p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(function () { avisaCarrito('fetch ' + url.split('?')[0]); }, 250); })
         .catch(function () {});
      }
      return p;
    };
  })();

  /* ── estado del carrito · una sola petición, sin polling ── */
  function leeCarrito(listo) {
    if (window.Cart47 && window.Cart47.estado) {
      try {
        var c = window.Cart47.estado();
        if (c) { ctx.carrito = c.item_count || 0; ctx.valor = (c.total_price || 0) / 100; ctx.items = c.items || []; return listo(); }
      } catch (e) {}
    }
    if (!window.fetch) return listo();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { ctx.carrito = c.item_count || 0; ctx.valor = (c.total_price || 0) / 100; ctx.items = c.items || []; })
      .catch(function () {})
      .then(listo);
  }

  window.Pgx47 = {
    configura: function (o) {
      if (!o) return;
      if (PRUEBA) { cfg.holdout = 0; o = { max: o.max, enfriado: o.enfriado }; }
      if (o.max != null) cfg.max = Math.max(1, parseInt(o.max, 10) || 2);
      if (o.enfriado != null) cfg.enfriado = Math.max(0, parseInt(o.enfriado, 10) || 0);
      if (o.holdout != null) cfg.holdout = Math.min(50, Math.max(0, parseInt(o.holdout, 10) || 0));
    },
    registra: function (def) { regs.push(def); conecta(); },
    intenta: intenta, cierra: cierra, pub: pub,
    Reloj: Reloj, ctx: ctx, ss: ss, ls: ls, ahora: ahora,
    QA: QA, log: log, marca: marca, estado: estado, diagrama: diagrama,
    PRUEBA: PRUEBA, dias: dias,
    leeCarrito: leeCarrito, alCambiarCarrito: alCambiarCarrito, midaHueco: midaHueco,
    esControl: esControl,
    hayAbierto: function () { return !!abierto; }
  };
})();


/* ══════════════════════════════════════════════════════════════════
   P1 · CAPTACIÓN · correo a cambio de un 5% real en BOX CONQUISTAR
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__pgx47p1) return;
  window.__pgx47p1 = 1;

  var raiz = document.querySelector('[data-pgx47-p1]');
  if (!raiz || !window.Pgx47) return;

  var E = window.Pgx47;
  var d = function (k) { return raiz.getAttribute('data-pgx47-' + k) || ''; };

  var K_MAIL = '47x_email_captured';          /* misma clave que usa la suscripción del pie */
  var K_VISTO = 'pgx47:p1:visto';
  var K_ENVIADO = 'pgx47:p1:enviado';
  var diasExcl = E.dias(parseInt(d('exclusion'), 10) || 75);
  var diasVisto = E.dias(parseInt(d('reaparece'), 10) || 7);
  var segundos = parseFloat(d('delay')) || 10;
  var pctScroll = parseFloat(d('scroll')) || 30;

  function vencido(clave, dias) {
    var t = parseInt(E.ls(clave) || '0', 10) || 0;
    if (!t && E.ls(clave) === 'true') return false;      /* marca vieja sin fecha */
    return !t || (E.ahora() - t) > dias * 86400000;
  }
  function yaCapturado() {
    if (document.documentElement.getAttribute('data-mail47-suscrito') === '1') return true;
    return !vencido(K_MAIL, diasExcl);
  }

  var def = {
    id: 'p1',
    prioridad: 2,                              /* P3=1 · P1=2 · P2=3 */
    nodo: raiz,
    gastado: false,
    reloj: null,
    /* Devuelve '' si puede salir, o el nombre de la regla que lo frena. */
    puede: function (ctx) {
      if (E.QA.activo) return '';
      if (d('on') !== '1') return 'disabled_in_theme_editor';
      if (yaCapturado()) return 'email_already_captured';
      if (E.ss('pgx47:p1:cerrado') === '1') {
        /* en pruebas, "cerrado" caduca a los 2 min para poder repetir */
        var t = parseInt(E.ss('pgx47:p1:cerradoT') || '0', 10) || 0;
        if (!E.PRUEBA || (E.ahora() - t) < 120000) return 'closed_this_session';
      }
      if (ctx.cliente) return 'known_customer';
      /* El carrito manda sobre la captación: si ya metió algo, lo que
         necesita es terminar la compra, no que le pidamos el correo. */
      if (ctx.carrito > 0) return 'cart_not_empty';
      if (!vencido(K_VISTO, diasVisto)) return 'seen_recently (' + diasVisto + 'd)';
      return '';
    },
    antesDeAbrir: function () {
      /* la imagen no existe hasta este momento: quien nunca ve el popup
         no paga un solo byte de la foto */
      var ims = raiz.querySelectorAll('img[data-pgx47-src]');
      for (var i = 0; i < ims.length; i++) {
        ims[i].src = ims[i].getAttribute('data-pgx47-src');
        ims[i].removeAttribute('data-pgx47-src');
      }
    },
    alAbrir: function (motivo) {
      E.marca(function () { E.ls(K_VISTO, String(E.ahora())); });
      E.pub('popup_viewed', { popup_id: 'p1_captacion', motivo: motivo });
      if (window.matchMedia('(min-width:860px)').matches) {
        var c = raiz.querySelector('[data-pgx47-email]');
        if (c) { try { c.focus({ preventScroll: true }); } catch (e) { } }
      }
    },
    alCerrar: function (como) {
      E.marca(function () {
        E.ss('pgx47:p1:cerrado', '1');
        E.ss('pgx47:p1:cerradoT', String(E.ahora()));
      });
      E.pub('popup_closed', { popup_id: 'p1_captacion', como: como });
    }
  };

  E.registra(def);

  var cierres = raiz.querySelectorAll('[data-pgx47-cerrar]');
  for (var i = 0; i < cierres.length; i++) {
    cierres[i].addEventListener('click', function () { E.cierra('boton'); });
  }

  /* ── envío ────────────────────────────────────────────────────
     NATIVO a propósito. Se intentó por fetch y esta tienda responde
     400 · "Missing CAPTCHA token": el CAPTCHA invisible de Shopify solo
     se resuelve en el envío del formulario. Lo que sí se corrige es el
     destino: se le quita el #contact_form a la acción para que la vuelta
     no arrastre un ancla al pie de página. */
  var form = raiz.querySelector('form.pgx47__form');
  if (form) {
    try {
      var acc = form.getAttribute('action') || '';
      if (acc.indexOf('#') > -1) form.setAttribute('action', acc.split('#')[0]);
    } catch (e) {}
    form.addEventListener('submit', function () {
      E.marca(function () { E.ss(K_ENVIADO, '1'); });
      E.pub('popup_email_submitted', { popup_id: 'p1_captacion' });
    });
  }

  var usar = raiz.querySelector('[data-pgx47-usar]');
  if (usar) {
    usar.addEventListener('click', function () {
      E.pub('popup_offer_redeemed', { popup_id: 'p1_captacion', codigo: d('codigo') });
      E.pub('popup_clicked', { popup_id: 'p1_captacion', destino: usar.getAttribute('href') });
    });
  }

  /* ── al volver del envío: la misma caja, ya en modo éxito ── */
  function vueltaDelEnvio() {
    /* La comprobación ya se hizo arriba, en cuanto arrancó el script. No se
       relee la URL porque para cuando llega aquí otro script pudo haberla
       limpiado, y entonces el éxito no se mostraría nunca.
       Tampoco se borra la marca `enviado`: mientras siga puesta, el aviso del
       pie sabe que esta confirmación es del popup y se aparta. Como el
       parámetro desaparece del URL, un refresh no puede repetir nada. */
    E.marca(function () { E.ls(K_MAIL, String(E.ahora())); });
    raiz.classList.add('is-ok');
    def.puede = function () { return true; };     /* este caso siempre se muestra */
    E.intenta('exito');
    /* fuera el parámetro para que un refresh no lo repita · sin recargar */
    try {
      var q = location.search.replace(/^\?/, '').split('&').filter(function (p) {
        return p && p.split('=')[0] !== 'customer_posted';
      });
      history.replaceState(history.state, '', location.pathname + (q.length ? '?' + q.join('&') : '') + location.hash);
    } catch (e) {}
    return true;
  }

  /* ── arranque ──────────────────────────────────────────────────
     Primero se lee el carrito (decide la prioridad) y solo después se
     arman los disparadores. Nunca en el primer fotograma. */
  /* El parámetro se reclama de inmediato, sin esperar al carrito: otro script
     de la página también reacciona a customer_posted=true y podría limpiarlo
     antes. Reclamarlo aquí hace que el orden de carga deje de importar. */
  var esVuelta = (location.search.indexOf('customer_posted=true') !== -1) && E.ss(K_ENVIADO) === '1';

  E.leeCarrito(function () {
    if (E.QA.activo && E.QA.popup === 'p1') { E.intenta('qa'); return; }
    if (esVuelta && vueltaDelEnvio()) return;

    /* tráfico pagado: no interrumpir el aterrizaje, se le da más aire */
    var ms = (E.ctx.pago ? segundos + 6 : segundos) * 1000;

    var t0 = E.ahora();
    def.reloj = new E.Reloj(ms, function () { E.intenta('tiempo'); });
    if (E.QA.log) {
      var avisa = setInterval(function () {
        if (E.hayAbierto() || def.gastado) { clearInterval(avisa); return; }
        var seg = Math.round((E.ahora() - t0) / 1000), tope = Math.round(ms / 1000);
        if (seg >= tope) { clearInterval(avisa); return; }
        E.log('P1 WAITING: ' + seg + '/' + tope + ' segundos');
      }, 5000);
    }
    if (document.readyState === 'complete') def.reloj.arranca();
    else window.addEventListener('load', function () { def.reloj.arranca(); }, { once: true });

    /* scroll real, medido en porcentaje del documento */
    var visto = false;
    function porScroll() {
      if (visto) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      var pct = Math.round(((window.scrollY || 0) / h) * 100);
      if (pct < pctScroll) { E.log('P1 WAITING: scroll ' + pct + '/' + pctScroll); return; }
      visto = true;
      window.removeEventListener('scroll', porScroll);
      E.intenta('scroll');
    }
    window.addEventListener('scroll', porScroll, { passive: true });
  });
})();


/* ══════════════════════════════════════════════════════════════════
   P2 · CONSIDERACIÓN CONTEXTUAL · sin correo y sin descuento nuevo

   A quién busca: al que ya mostró interés y todavía no agregó nada.
   Su único trabajo es llevarlo a la oferta que encaja con lo que está
   mirando. Si el contexto no está claro, NO sale: un popup genérico
   disparándose por obligación resta más de lo que suma.

   Los tres contextos vienen pintados desde Liquid dentro del mismo
   contenedor; aquí solo se le pone la clase al que toca. Cero nodos
   creados, cero movidos, cero scroll.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__pgx47p2) return;
  window.__pgx47p2 = 1;

  var raiz = document.querySelector('[data-pgx47-p2]');
  if (!raiz || !window.Pgx47) return;

  var E = window.Pgx47;
  var d = function (k) { return raiz.getAttribute('data-pgx47-' + k) || ''; };

  var K_CERRADO = 'pgx47:p2:cerrado';    /* lo cerró o hizo clic: fuera por esta sesión */
  var K_CANCEL  = 'pgx47:p2:cancelado';  /* agregó al carrito: manda P3 */
  var segundos  = parseFloat(d('delay')) || 40;
  var pctScroll = parseFloat(d('scroll')) || 45;

  /* ── contexto ────────────────────────────────────────────────────
     Se decide por la ruta (handle/template) o por una sección que esté
     o haya estado en pantalla. Lo segundo es lo que hace que funcione
     en el home, donde la ruta no dice nada. */
  var ctxs = [].slice.call(raiz.querySelectorAll('[data-pgx47-ctx]'));
  var vistas = {};

  var enPantalla = {};
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (ents) {
      for (var i = 0; i < ents.length; i++) {
        var k = ents[i].target.__pgxctx;
        if (ents[i].isIntersecting) { vistas[k] = 1; enPantalla[k] = 1; }
        else { delete enPantalla[k]; }
      }
    }, { threshold: 0.35 });
    for (var c = 0; c < ctxs.length; c++) {
      var sel = ctxs[c].getAttribute('data-pgx47-seccion');
      if (!sel) continue;
      var nodos = document.querySelectorAll(sel);
      for (var n = 0; n < nodos.length; n++) { nodos[n].__pgxctx = ctxs[c].getAttribute('data-pgx47-ctx'); io.observe(nodos[n]); }
    }
  }

  function eligeContexto() {
    /* En QA se puede pedir el contexto por URL, para revisar los tres
       diseños sin tener que ir a tres páginas distintas. */
    if (E.QA.activo && E.QA.contexto) {
      for (var q = 0; q < ctxs.length; q++) {
        if (ctxs[q].getAttribute('data-pgx47-ctx') === E.QA.contexto) return ctxs[q];
      }
      E.log('P2 QA: el contexto «' + E.QA.contexto + '» no existe · usa mystery, pack6 o studios');
      return null;
    }
    var ruta = (location.pathname + location.search).toLowerCase();
    /* 1 · la ruta manda: es la señal más fuerte de qué está mirando */
    for (var i = 0; i < ctxs.length; i++) {
      var frag = (ctxs[i].getAttribute('data-pgx47-coincide') || '').toLowerCase().split(',');
      for (var f = 0; f < frag.length; f++) {
        var t = frag[f].trim();
        if (t && ruta.indexOf(t) !== -1) return ctxs[i];
      }
    }
    /* 2 · lo que está EN PANTALLA en este momento. Antes se usaba "lo que
       llegó a verse alguna vez", y como el hero es lo primero que aparece,
       el mensaje acababa siendo siempre el de Mystery aunque la persona
       estuviera mirando otra cosa. */
    for (var v = 0; v < ctxs.length; v++) {
      if (enPantalla[ctxs[v].getAttribute('data-pgx47-ctx')]) return ctxs[v];
    }
    /* 3 · si nada coincide ahora, lo último que sí estuvo en pantalla */
    var ultimo = null;
    for (var j = 0; j < ctxs.length; j++) {
      if (vistas[ctxs[j].getAttribute('data-pgx47-ctx')]) ultimo = ctxs[j];
    }
    if (ultimo) return ultimo;
    /* 4 · respaldo: la oferta principal del home. Antes aquí se cancelaba
       el popup, y en la práctica eso lo dejaba mudo casi siempre. */
    for (var k = 0; k < ctxs.length; k++) {
      if (ctxs[k].getAttribute('data-pgx47-respaldo') === '1') return ctxs[k];
    }
    return ctxs[0] || null;
  }

  var elegido = null;

  var def = {
    id: 'p2',
    prioridad: 3,                         /* P3=1 · P1=2 · P2=3 */
    nodo: raiz,
    gastado: false,
    reloj: null,
    /* Tres condiciones y ninguna más: carrito vacío, no cancelado, y no
       mostrado ya. El 55% de recorrido y los 60 s desde P1 los imponen el
       disparador y el enfriado del motor, no otra capa de reglas: apilar
       condiciones era lo que lo dejaba bloqueado para siempre. */
    puede: function (ctx) {
      if (d('on') !== '1') return 'disabled_in_theme_editor';
      if (E.ss(K_CERRADO) === '1') {
        var tc = parseInt(E.ss(K_CERRADO + 'T') || '0', 10) || 0;
        if (!E.PRUEBA || (E.ahora() - tc) < 120000) return 'already_shown_or_closed';
      }
      if (E.ss(K_CANCEL) === '1') return 'cancelled_by_add_to_cart';
      /* En cuanto hay carrito, P2 deja de tener sentido: ya no hay que
         venderle el producto, hay que ayudarle a cerrar. Manda P3. */
      if (ctx.carrito > 0) { E.marca(function () { E.ss(K_CANCEL, '1'); }); return 'cart_not_empty'; }
      elegido = eligeContexto();
      return '';                       /* sin contexto claro usa el de respaldo */
    },
    antesDeAbrir: function () {
      elegido = eligeContexto();          /* con lo que hay en pantalla AHORA */
      for (var i = 0; i < ctxs.length; i++) ctxs[i].classList.remove('is-activo');
      if (elegido) elegido.classList.add('is-activo');
      var ims = raiz.querySelectorAll('img[data-pgx47-src]');
      for (var k = 0; k < ims.length; k++) {
        ims[k].src = ims[k].getAttribute('data-pgx47-src');
        ims[k].removeAttribute('data-pgx47-src');
      }
    },
    alAbrir: function (motivo) {
      /* una sola vez por sesión: se marca al abrir, no al cerrar */
      E.marca(function () { E.ss(K_CERRADO, '1'); E.ss(K_CERRADO + 'T', String(E.ahora())); });
      E.pub('popup_viewed', { popup_id: 'p2', context: elegido ? elegido.getAttribute('data-pgx47-ctx') : '', motivo: motivo });
    },
    alCerrar: function (como) {
      E.marca(function () { E.ss(K_CERRADO, '1'); E.ss(K_CERRADO + 'T', String(E.ahora())); });
      E.pub('popup_closed', { popup_id: 'p2', context: elegido ? elegido.getAttribute('data-pgx47-ctx') : '', como: como });
    }
  };

  E.registra(def);

  var cierres = raiz.querySelectorAll('[data-pgx47-cerrar]');
  for (var q = 0; q < cierres.length; q++) {
    cierres[q].addEventListener('click', function () { E.cierra('boton'); });
  }
  var ctas = raiz.querySelectorAll('[data-pgx47-ir]');
  for (var w = 0; w < ctas.length; w++) {
    ctas[w].addEventListener('click', function (ev) {
      E.marca(function () { E.ss(K_CERRADO, '1'); });
      E.pub('popup_clicked', { popup_id: 'p2',
        context: elegido ? elegido.getAttribute('data-pgx47-ctx') : '',
        destino: ev.currentTarget.getAttribute('href') });
    });
  }

  /* Si agrega algo al carrito antes de que salte, P2 queda cancelado y
     la prioridad pasa a P3. Se escucha el evento propio del tema: sin
     polling y sin peticiones extra. */
  E.alCambiarCarrito(function () {
    if (E.ctx.carrito <= 0) return;
    E.marca(function () { E.ss(K_CANCEL, '1'); });
    if (def.reloj) def.reloj.mata();
    def.gastado = true;
    E.log('P2 CANCELADO: hay carrito · a partir de aquí manda P3');
    if (raiz.classList.contains('is-abierto')) E.cierra('carrito');
  });

  /* ── disparadores ── */
  E.leeCarrito(function () {
    if (E.QA.activo && E.QA.popup === 'p2') { E.intenta('qa'); return; }
    if (E.ctx.carrito > 0) {
      E.marca(function () { E.ss(K_CANCEL, '1'); });
      E.log('P2 BLOCKED: cart_not_empty (' + E.ctx.carrito + ' art.)');
      return;
    }

    var t0 = E.ahora();
    def.reloj = new E.Reloj(segundos * 1000, function () { E.intenta('tiempo'); });
    if (E.QA.log) {
      var avisa = setInterval(function () {
        if (E.hayAbierto() || def.gastado) { clearInterval(avisa); return; }
        var seg = Math.round((E.ahora() - t0) / 1000);
        if (seg >= segundos) { clearInterval(avisa); return; }
        E.log('P2 WAITING: ' + seg + '/' + segundos + ' segundos');
      }, 5000);
    }
    if (document.readyState === 'complete') def.reloj.arranca();
    else window.addEventListener('load', function () { def.reloj.arranca(); }, { once: true });

    var ya = false;
    function porScroll() {
      if (ya) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      var pct = Math.round(((window.scrollY || 0) / h) * 100);
      if (pct < pctScroll) { E.log('P2 WAITING: scroll ' + pct + '/' + pctScroll); return; }
      ya = true;
      window.removeEventListener('scroll', porScroll);
      E.intenta('scroll');
    }
    window.addEventListener('scroll', porScroll, { passive: true });
  });
})();

/* ══════════════════════════════════════════════════════════════════
   P3 · CIERRE · ayudar a terminar la compra

   Solo existe con carrito. No salta al agregar: eso sería quitarle al
   cliente el momento en que acaba de decidir. Espera a que siga
   navegando, o a que cierre el carrito, y entonces ofrece el atajo.

   Lee el carrito de verdad: número de piezas, subtotal, y cuánto falta
   para el envío gratis. Sin overlay negro, sin bloquear el recorrido.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.__pgx47p3) return;
  window.__pgx47p3 = 1;

  var raiz = document.querySelector('[data-pgx47-p3]');
  if (!raiz || !window.Pgx47) return;

  var E = window.Pgx47;
  var d = function (k) { return raiz.getAttribute('data-pgx47-' + k) || ''; };

  var K_HECHO = 'pgx47:p3:hecho';
  var espera  = (parseFloat(d('delay')) || 25) * 1000;
  var umbral  = parseFloat(d('envio')) || 1399;

  function moneda(n) {
    try { return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 }); }
    catch (e) { return '$' + Math.round(n); }
  }

  /* CARRITO MIXTO · se muestra el plazo MÁS LARGO aplicable.
     Si la bolsa trae una pieza de producción bajo pedido (hoy el Anime
     Jogger Drop), prometer el plazo general sería mentir. La sección
     manda los IDs de esa colección y el texto alterno; aquí solo se
     compara y se cambia la línea. Si no hay ninguna, queda el general. */
  function plazoReal() {
    try {
      var el = raiz.querySelector('[data-pgx47-entrega]');
      if (!el) return;
      var txt = el.getAttribute('data-pgx47-sla-larga');
      var ids = (el.getAttribute('data-pgx47-sla-ids') || '').split(',').filter(Boolean);
      if (el.__base == null) el.__base = el.textContent;
      if (!txt || !ids.length) return;
      var hay = (E.ctx.items || []).some(function (it) {
        return ids.indexOf(String(it.product_id)) !== -1;
      });
      el.textContent = hay ? txt : el.__base;
    } catch (e) {}
  }

  function pinta() {
    var n = E.ctx.carrito, v = E.ctx.valor;
    plazoReal();
    var l1 = raiz.querySelector('[data-pgx47-p3-linea]');
    var l2 = raiz.querySelector('[data-pgx47-p3-envio]');
    if (l1) l1.textContent = n + (n === 1 ? ' producto · ' : ' productos · ') + moneda(v);
    if (l2) {
      if (v >= umbral) { l2.textContent = d('envio-ok') || 'ENVÍO GRATIS DESBLOQUEADO'; l2.className = 'pgx47__p3envio is-ok'; }
      else { l2.textContent = (d('envio-falta') || 'TE FALTAN {x} PARA ENVÍO GRATIS').replace('{x}', moneda(umbral - v));
             l2.className = 'pgx47__p3envio'; }
    }
  }

  var def = {
    id: 'p3',
    prioridad: 1,                         /* manda sobre P1 y P2 */
    nodo: raiz,
    gastado: false,
    reloj: null,
    puede: function (ctx) {
      if (d('on') !== '1') return 'disabled_in_theme_editor';
      if (E.ss(K_HECHO) === '1') return 'already_shown_this_session';
      if (ctx.carrito <= 0) return 'empty_cart';
      return '';
    },
    antesDeAbrir: function () {
      pinta();
      var ims = raiz.querySelectorAll('img[data-pgx47-src]');
      for (var i = 0; i < ims.length; i++) {
        ims[i].src = ims[i].getAttribute('data-pgx47-src');
        ims[i].removeAttribute('data-pgx47-src');
      }
    },
    alAbrir: function (motivo) {
      E.marca(function () { E.ss(K_HECHO, '1'); });
      E.pub('popup_viewed', { popup_id: 'p3', motivo: motivo, cart_count: E.ctx.carrito });
    },
    alCerrar: function (como) { E.pub('popup_closed', { popup_id: 'p3', como: como }); }
  };

  E.registra(def);

  var cierres = raiz.querySelectorAll('[data-pgx47-cerrar]');
  for (var i = 0; i < cierres.length; i++) {
    cierres[i].addEventListener('click', function () { E.cierra('boton'); });
  }
  var ir = raiz.querySelector('[data-pgx47-checkout]');
  if (ir) ir.addEventListener('click', function () {
    E.pub('popup_checkout_started', { popup_id: 'p3', cart_value: E.ctx.valor });
    E.pub('popup_clicked', { popup_id: 'p3' });
  });

  /* ── cuándo ─────────────────────────────────────────────────────
     Nunca al agregar. El reloj arranca cuando el carrito deja de estar
     vacío y la persona sigue en la tienda; se reinicia si cierra el
     drawer, que es la señal más clara de "ya terminé de mirar esto". */
  function arma(motivo) {
    if (def.gastado || E.ss(K_HECHO) === '1') return;
    if (def.reloj) def.reloj.mata();
    def.reloj = new E.Reloj(espera, function () { E.intenta(motivo); });
    def.reloj.arranca();
    E.log('P3 armado · ' + Math.round(espera / 1000) + 's desde ' + motivo);
  }

  E.alCambiarCarrito(function (origen) {
    if (E.ctx.carrito > 0) arma(origen);
  });

  /* exit intent real · solo escritorio, solo con puntero fino */
  if (window.matchMedia('(min-width:860px) and (pointer:fine)').matches) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.clientY > 8) return;
      if (E.ctx.carrito <= 0) return;
      E.intenta('exit-intent');
    });
  }

  E.leeCarrito(function () {
    pinta();
    if (E.ctx.carrito > 0) arma('carga-con-carrito');
  });
})();
